import React, { useState, useEffect } from "react";
import WebMapView from "../map";
import axios from "axios";

export const Main = () => {
  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");
  const [data, setData] = useState([]);
  const update = (value1, value2) => {
    setLat(value1);
    setLon(value2);
  };

  useEffect(() => {
    axios
      .get(
        `https://api.seatgeek.com/2/events?client_id=MjE0Mzk5Njd8MTYwODAwNjc0Ny4xMzcwMTQ2&lat=${lat}&lon=${lon}&range=12mi`
      )
      .then((response) => response.data)
      .then((response) => setData(response.events))
      .catch((err) => console.log(err));

    // const proxy = `https://cors-anywhere.herokuapp.com/`;
    // axios
    //   .get(`${proxy}http://testdemo.azurewebsites.net/weatherforecast`)
    //   .then((response) => response.data)
    //   .then((response) => setData(response))
    //   .catch((e) => {
    //     console.log(e);
    //   });
  }, [lat, lon]);

  return (
    <div>
      <div>
        <h3 style={{ color: "#fcba03" }}>Search events near you</h3>
        {/* <input type="text" /> */}
      </div>

      {/* <br /> */}

      <WebMapView update={update} data={data} />
    </div>
  );
};
